module.exports = __webpack_public_path__ + "img/vertical_7_3_5010.e73a491c.png";